import http from '@/http';

export default class CandidatoService {

	getCandidatos() {
		console.log('CandidatoService.getCandidatos ...');
		return http.get('usuario/candidatos').then(res => res.data);
    }

	create(candidato){
		console.log('CandidatoService.create');
		console.log(JSON.stringify(candidato));
		return http.post('usuario', candidato).then(res => res.data);
	}

	update(candidato){
		console.clear();
		console.log('CandidatoService.update');
		console.log(JSON.stringify(candidato));
		return http.put(`usuario/${candidato.id}`, candidato).then(res => res.data);
	}

	parseToUsuarioDTO(candidato){

		return  {
			id : candidato.id,
			nome : candidato.nome,
			email : candidato.email,
			confimeEmail : candidato.email,
			cpf : candidato.cpf,
			rg : parseInt(candidato.rg),
			data_nascimento : this.formatarDataBR(candidato.data_nascimento),
			sexo : this.findSexoByCode(candidato.sexo),
			idEndereco : candidato.enderecos[0].id,
			cep : candidato.enderecos[0].cep,
			logradouro : candidato.enderecos[0].logradouro,
			numero : parseInt(candidato.enderecos[0].numero),
			complemento : candidato.enderecos[0].complemento,
			bairro : candidato.enderecos[0].bairro,
			uf : candidato.enderecos[0].cidade.estado.uf,
			cidade : candidato.enderecos[0].cidade.nome,
			celular : candidato.celular.celular,
		}

	}

	formatarDataBR(dataUS) {
		var dataFormatada = dataUS.substring(0, 11);
		dataFormatada = dataFormatada.split('-').reverse().join('/')
		return dataFormatada;
	}

	findSexoByCode(code) {
		let sexo = [];
		let sexos = this.getSexos();
		for (let i = 0; i < sexos.length; i++) {
			if (sexos[i].code === code) {
				sexo = sexos[i];
				break;
			}
		}
		return sexo;
	}

	getSexos(){
		return [
			{name: 'Feminino', code: 'F'},
			{name: 'Masculino', code: 'M'}
		];
	}

}
